import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
import { noop } from 'lodash';

function FormToggle(_ref) {
  let {
    className,
    checked,
    id,
    disabled,
    onChange = noop,
    ...props
  } = _ref;
  const wrapperClasses = classnames('components-form-toggle', className, {
    'is-checked': checked,
    'is-disabled': disabled
  });
  return createElement("span", {
    className: wrapperClasses
  }, createElement("input", _extends({
    className: "components-form-toggle__input",
    id: id,
    type: "checkbox",
    checked: checked,
    onChange: onChange,
    disabled: disabled
  }, props)), createElement("span", {
    className: "components-form-toggle__track"
  }), createElement("span", {
    className: "components-form-toggle__thumb"
  }));
}

export default FormToggle;
//# sourceMappingURL=index.js.map